<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Imprimir Documentos</h4>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #form="ngForm" class="form" novalidate>

      <div class="form-group" *ngFor="let quotation of quotations">
        <div *ngIf="processedOrder.order.orderType === 'QUOTATION'">
          <ui-switch size="small" [(ngModel)]="quotation.print" name="QUOTATION"></ui-switch>
          <span class="m-4">Cotización: {{processedOrder.order.code}}</span>
        </div>
      </div>

      <div class="form-group"
        [hidden]="processedOrder.order.status == 'FINAL'
        || (processedOrder.order.orderCondition != UNTIL_30_DAYS_FRANCHISED && processedOrder.order.orderCondition != MORE_THAN_30_DAYS_FRANCHISED)">
        <ui-switch size="small" [(ngModel)]="purchaseOrder.print" name="purchaseOrder" ngDefaultControl></ui-switch>
        <span class="m-4">Generar reporte orden de compra:</span>
      </div>

      <div class="form-group"
        *ngIf="!canShowDigitalSignatureDocs || isDigitalSignatureRejected || isFranchisedInvoices">
        <div class="form-group" *ngFor="let invoice of invoices; let i = index">
          <ui-switch size="small" [(ngModel)]="invoice.print" name="ïnvoice{{invoice.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Factura {{invoice.printType === 'ORIGINAL' ? 'Original' : 'Copia'}}:
            {{invoice.fullNumber}}</span>
        </div>
      </div>

      <div class="form-group">
        <div class="form-group" *ngFor="let creditNote of creditNotes; let i = index">
          <ui-switch size="small" [(ngModel)]="creditNote.print" name="creditNote{{creditNote.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Nota de crédito {{creditNote.fullNumber}}</span>
        </div>
      </div>
      <div class="form-group">
        <div class="form-group" *ngFor="let receiptRollback of receiptRollbacks; let i = index">
          <ui-switch size="small" [(ngModel)]="receiptRollback.print" name="receiptRollback{{receiptRollback.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Reversión de Recibo {{receiptRollback.fullNumber || receiptRollback.receiptCode}}</span>
        </div>
      </div>

      <div class="form-group">
        <div class="form-group" *ngFor="let voucher of vouchers; let i = index">
          <ui-switch size="small" [(ngModel)]="voucher.print" name="voucher{{voucher.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Vale de caja {{voucher.code}}</span>
        </div>
      </div>

      <div class="form-group">
        <div class="form-group" *ngFor="let returnReceipt of returnReceipts; let i = index">
          <ui-switch size="small" [(ngModel)]="returnReceipt.print" name="returnReceipt{{returnReceipt.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Recibo de cargo administrativo {{returnReceipt.code}}</span>
        </div>
      </div>

      <div *ngIf="validationShowManualDocuments">
        <div class="form-group" *ngFor="let loanr of loan">
          <div>
            <ui-switch size="small" [(ngModel)]="loanr.print" name="loan{{loanr.code}}" ngDefaultControl></ui-switch>
            <span class="m-4">Contrato: {{loanr.code}}</span>
          </div>
        </div>

        <div class="form-group">
          <div *ngFor="let plan of paymentPlan">
            <ui-switch size="small" [(ngModel)]="plan.print" name="plan{{plan.code}}" ngDefaultControl></ui-switch>
            <span class="m-4">Plan de pago: {{plan.code}}</span>
          </div>
        </div>

      </div>

      <div class="form-group" *ngIf="settlement.code">
        <div>
          <ui-switch size="small" [(ngModel)]="settlement.print" name="settlement{{settlement.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Finiquito: {{settlement.code}}</span>
        </div>
      </div>

      <div class="form-group">
        <div class="form-group" *ngFor="let loanC of loanCancellations">
          <div>
            <ui-switch size="small" [(ngModel)]="loanC.print" name="loanCancellation{{loanC.code}}"
              ngDefaultControl></ui-switch>
            <span class="m-4">Cancelación de Contrato: {{loanC.contractNumber}}</span>
          </div>
        </div>
      </div>

      <div *ngIf="!canShowDigitalSignatureDocs || isDigitalSignatureRejected">
        <div *ngFor="let debit of debitNote">
          <div class="form-group">
            <ui-switch size="small" [(ngModel)]="debit.print" name="receipt{{debit.code}}"
              ngDefaultControl></ui-switch><span class="m-4">Nota de cargo: {{debit.code}}</span>
          </div>
        </div>
      </div>

      <div *ngFor="let receipt of receipts">
        <div class="form-group">
          <ui-switch size="small" [(ngModel)]="receipt.print" name="receipt{{receipt.code}}"
            ngDefaultControl></ui-switch><span class="m-4">Recibo: {{receipt.code}}</span>
        </div>
      </div>

      <div class="form-group" *ngIf="!canShowDigitalSignatureDocs || isDigitalSignatureRejected">
        <div *ngFor="let note of promissoryNotes">
          <ui-switch size="small" [(ngModel)]="note.print" name="note{{note.code}}" ngDefaultControl></ui-switch><span
            class="m-4">Pagaré: {{note.code}}</span>
        </div>
      </div>

      
      <!-- Refinanciamiento -->
      <div class="form-group" *ngIf="!canShowDigitalSignatureDocs || isDigitalSignatureRejected">
        <div *ngFor="let refinan of refinancing">
          <ui-switch size="small" [(ngModel)]="refinan.print" name="refinancing{{refinan.code}}" ngDefaultControl></ui-switch><span
            class="m-4">Refinanciamiento: {{refinan.code}}</span>
        </div>
      </div>


      <div class="form-group" *ngFor="let extraWarranty of extraWarrantyCertificate">
        <ui-switch size="small" [(ngModel)]="extraWarranty.print" name="note{{extraWarranty.invoiceCode}}"
          ngDefaultControl></ui-switch><span class="m-4">Extragarantia</span>
      </div>

      <div class="form-group" *ngIf="creditReference.customerCode">
        <ui-switch size="small" [(ngModel)]="creditReference.print" name="creditReference" ngDefaultControl></ui-switch>
        <span class="m-4">Referencia de Credito</span>

        <div class="row" *ngIf="creditReference.print">
          <div class="col-md-12 mb-3 mt-2">
            <label>Dirigido A</label>
            <input class="form-control" type="text" name="creditReferenceInput" [(ngModel)]="creditReference.toWhom"
              [ngClass]="creditReference.toWhom.length == 0 ? 'is-invalid' : 'is-valid'" />
          </div>
        </div>
      </div>
      <div class="form-group" *ngFor="let invoiceRequest of invoiceRequests; let i = index">
        <ui-switch size="small" [(ngModel)]="invoiceRequest.print" name="invoiceRequest{{invoiceRequest.code}}"
          ngDefaultControl></ui-switch>
        <span class="m-4">Solicitud de Reimpresión: {{invoiceRequest.fullNumber}}</span>
      </div>
      <div *ngIf="canShowDigitalSignatureDocs && isDigitalSignatureDone && !isDigitalSignatureRejected">
        <div class="form-group" *ngFor="let doc of digitalSignature.documents">
          <ui-switch size="small" [(ngModel)]="doc.print" name="receipt{{doc.code}}" ngDefaultControl></ui-switch>
          <span *ngIf="doc.documentType !== 'INVOICE' else isInvoice" class="m-4">{{
            getDigitalSignatureDocName(doc.documentType) }}: {{doc.fileName}}</span>
          <ng-template #isInvoice>
            <span class="m-4">{{ getDigitalSignatureDocName(doc.documentType) }} {{doc.printType === 'ORIGINAL' ?
              'Original' : 'Copia'}} : {{doc.fileName}}</span>
          </ng-template>

        </div>


        <div class="form-group" *ngFor="let invoice of originalInvoices; let i = index">
          <ui-switch size="small" [(ngModel)]="invoice.print" name="invoice{{invoice.code}}"
            ngDefaultControl></ui-switch>
          <span class="m-4">Factura {{invoice.printType === 'ORIGINAL' ? 'Original' : 'Copia'}}:
            {{invoice.fullNumber}} Sin Firma Digital</span>
        </div>

      </div>
      <div class="form-group" *ngFor="let cl of checklist">
        <ui-switch size="small" [(ngModel)]="cl.print" name="checklist" ngDefaultControl></ui-switch><span
          class="m-4">Checklist: {{cl.checklistCode}}</span>
      </div>
      <div class="form-group" *ngIf="productVerification.code">
        <ui-switch size="small" [(ngModel)]="productVerification.print" name="productVerification"
          ngDefaultControl></ui-switch><span class="m-4">Entrega de Productos</span>
      </div>

      <div class="form-group" *ngIf="productDelivery.code">
        <ui-switch size="small" [(ngModel)]="productDelivery.print" name="productDelivery"
          ngDefaultControl></ui-switch><span class="m-4">Constancia de Verificación Física y Funcional del
          Producto</span>
      </div>
      <div class="form-group" *ngIf="releaseOfResponsibility.code">
        <ui-switch size="small" [(ngModel)]="releaseOfResponsibility.print" name="releaseOfResponsibility"
          ngDefaultControl></ui-switch><span class="m-4">Liberación de Responsabilidad</span>
      </div>

      <div>
        <div class="form-group" *ngFor="let domainTradition of domainTraditionFiles">
          <ui-switch size="small" [(ngModel)]="domainTradition.print" name="{{domainTradition.invoiceNumber}}"
            ngDefaultControl></ui-switch><span class="m-4">Tradición de dominio:
            {{domainTradition.invoiceNumber}}</span>
        </div>
      </div>

      <div *ngIf="vehicleRegistration">
        <div class="form-group" *ngFor="let circulationPermit of circulationPermits">
          <ui-switch size="small" [(ngModel)]="circulationPermit.print" name="vehicleRegistration"
            ngDefaultControl></ui-switch><span class="m-4">Permiso de circulación: {{circulationPermit.code}}</span>
        </div>


        <div class="form-group" *ngIf="ip800File.code">
          <ui-switch size="small" [(ngModel)]="ip800File.print" name="ip800" ngDefaultControl></ui-switch><span
            class="m-4">IP800</span>
        </div>

        <div class="form-group">
          <ui-switch size="small" [(ngModel)]="registrationRefusal.print" name="registrationRefusal"
            ngDefaultControl></ui-switch>
          <span class="m-4">Rechazo de matricula</span>

          <div class="row" *ngIf="registrationRefusal.print">
            <div class="col-md-12 mb-3 mt-2">
              <label>Ubicación</label>
              <input class="form-control" type="text" name="identity" [(ngModel)]="registrationRefusal.location"
                [ngClass]="registrationRefusal.location.length == 0 ? 'is-invalid' : 'is-valid'" />
            </div>
          </div>


        </div>
        <div class="form-group" *ngFor="let warranty of warrantyCertificate">
          <ui-switch size="small" [(ngModel)]="warranty.print" name="warranty"></ui-switch><span class="m-4"
            ngDefaultControl>Garantía
            para factura: {{warranty.invoiceNumber}}</span>
        </div>

        <div class="form-group">
          <ui-switch size="small" [(ngModel)]="thirdPartyAuthoriztion.print" name="thirdPartyAuthoriztion"
            ngDefaultControl></ui-switch>
          <span class="m-4">Autorización de terceros</span>

          <div class="row" *ngIf="thirdPartyAuthoriztion.print">
            <div class="col-md-6 mb-3 mt-2">
              <label>Identificación</label>
              <input class="form-control" type="text" name="identity" [(ngModel)]="thirdPartyForm.identity"
                [ngClass]="thirdPartyForm.identity.length < 13 ? 'is-invalid' : 'is-valid'" />
            </div>
            <div class="col-md-6 mb-3 mt-2">
              <label>Nombre</label>
              <input class="form-control" type="text" name="name" [(ngModel)]="thirdPartyForm.name"
                [ngClass]="thirdPartyForm.name.length == 0 ? 'is-invalid' : 'is-valid'" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isForPrintRecollectionDocuments">
        <div class="form-group">
          <div class="form-group" *ngFor="let receipt of recollectionReceipts; let i = index">
            <ui-switch size="small" [(ngModel)]="receipt.print" name="recollectionReceipt{{receipt.code}}"
              ngDefaultControl></ui-switch>
            <span class="m-4">Recibo {{receipt.code}}</span>
          </div>
        </div>
        <div class="form-group">
          <div class="form-group" *ngFor="let invoice of recollectionInvoices; let i = index">
            <ui-switch size="small" [(ngModel)]="invoice.print" name="ïnvoice{{invoice.code}}"
              ngDefaultControl></ui-switch>
            <span class="m-4">Factura {{invoice.printType === 'ORIGINAL' ? 'Original' : 'Copia'}}:
              {{invoice.fullNumber}}</span>
          </div>
        </div>
      </div>

      <div *ngIf="isForAdvanceDocuments">
        <div class="form-group" *ngIf="advanceDocument.code">
          <ui-switch size="small" [(ngModel)]="advanceDocument.print" name="advance"></ui-switch>
          <span class="m-4">Anticipo: {{advanceDocument.receiptCode}}</span>
        </div>
        <div class="form-group" *ngIf="advanceReturnDocument.code">
          <ui-switch size="small" [(ngModel)]="advanceReturnDocument.print" name="advance"></ui-switch>
          <span class="m-4">Reversión de Anticipo: {{advanceReturnDocument.receiptCode}}</span>
        </div>
      </div>
      <div *ngIf="isForReimbursement">
        <div class="form-group" *ngIf="reimbursementDocument.documentNumber">
          <ui-switch size="small" [(ngModel)]="reimbursementDocument.print" name="advance"></ui-switch>
          <span class="m-4">{{reimbursementDocument.operation =='PAYMENT' ? 'Reembolso Caja Chica:' :
            'Anulación de Reembolso Caja Chica:'}}
            {{reimbursementDocument.documentNumber}}</span>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="selectAllDocuments()">Seleccionar todos</button>
    <button type="button" class="btn btn-outline-success" [disabled]="validatePrintButton()" (click)="print()">Imprimir
      seleccionados</button>
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
  </div>
</div><!-- /.modal-content -->